import axios from "axios";

import { apis } from "../Auth/Api";


export const getWeather = async () => {
    return await axios.get(`${apis.baseUrl}${apis.getWeather}`);
}


export const getAllDepartment = async () => {
    return await axios.get(`${apis.baseUrl}${apis.getAllDepartment}`);
};

export const getAllDepartmentById = async (id) => {
    return await axios.get(`${apis.baseUrl}${apis.getAllDepartment}${id}`);
};

export const getAllFaculty = async () => {
    return await axios.get(`${apis.baseUrl}${apis.getAllFaculty}`);
};

export const getAllFacultyById = async (id) => {
    return await axios.get(`${apis.baseUrl}${apis.getAllFaculty}${id}`);
};



export const getAllOMR = async () => {
    return await axios.get(`${apis.baseUrl}${apis.getAllOMR}`);
};


export const getAllOMRById = async (id) => {
    return await axios.get(`${apis.baseUrl}${apis.getAllOMR}${id}`);
};

export const getAllSyllabus = async () => {
    return await axios.get(`${apis.baseUrl}${apis.getAllSyllabus}`);
};


export const getAllExamRelatedInfo = async () => {
    return await axios.get(`${apis.baseUrl}${apis.getAllExamRelatedInfo}`);
};

export const getAllExamSchedule = async () => {
    return await axios.get(`${apis.baseUrl}${apis.getAllExamSchedule}`);
};

export const getAllRevisedExamSchedule = async () => {
    return await axios.get(`${apis.baseUrl}${apis.getAllRevisedExamSchedule}`);
};

export const getAllCodeBooksandDownloads = async () => {
    return await axios.get(`${apis.baseUrl}${apis.getAllCodeBooksandDownloads}`);
};

export const getAllCareerInfo = async () => {
    return await axios.get(`${apis.baseUrl}${apis.getAllCareerInfo}`);
};

export const getAllTendersInfo = async () => {
    return await axios.get(`${apis.baseUrl}${apis.getAllTendersInfo}`);
};

export const getAllSportsCalendar = async () => {
    return await axios.get(`${apis.baseUrl}${apis.getAllSportsCalendar}`);
};


export const getAllHomeData = async () => {
    return await axios.get(`${apis.baseUrl}${apis.getHomeData}`);
};

export const getAllSearchNewsData = async () => {
    return await axios.get(`${apis.baseUrl}${apis.getAllSearchNewsData}`);
};

export const getAllSearchNewsByCategoryData = async (id) => {
    return await axios.get(`${apis.baseUrl}${apis.getAllSearchNewsByCategoryData}${id}`);
};